"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.valuesOf = void 0;
// external
const t = __importStar(require("io-ts"));
// global
const invert_1 = require("./invert");
/**
 * We care about the values of an enum. This does not come out of the box with io-ts so we have to invert the enum first.
 * @param enm - The enum to invert
 * @returns The io-ts keyof
 */
function valuesOf(enm) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return t.keyof((0, invert_1.invert)(enm));
}
exports.valuesOf = valuesOf;
//# sourceMappingURL=valuesOf.js.map